import audioVisualizer from '../images/audio_visualizer.gif'
import mikrafonIcon from '../images/mikrafon.webp';

function EventListener({ mediaRecorderRef }) {
  setTimeout(() => {
    const stateIcon = document.getElementById('state-icon');
    const audioplay = document.getElementById("audioplay");
    const chatHeader = document.querySelector('.chat-area-header');

    if (audioplay && stateIcon) {
      audioplay.addEventListener('play', () => {
        stateIcon.src = audioVisualizer;
      });

      audioplay.addEventListener('ended', () => {
        stateIcon.src = mikrafonIcon;
      });
    }

    if (stateIcon) {
      stateIcon.onclick = () => {
        if (mediaRecorderRef.current?.state === 'recording') {
          console.log("stopping...");
          mediaRecorderRef.current.stop();
        } else {
          console.log("starting...");
          mediaRecorderRef.current.start(300);
        }
      };
    }

    // Agar chatHeader ham ishlatilsa, shart qo'shib qo'yish kerak:
    if (chatHeader) {
    }

  }, 100);
}

export default EventListener;
